module.exports = __webpack_public_path__ + "static/image-04-b@2x-c58dc78b81dfd1807bfc07fcee802180.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/laboratoria/image-04-b@2x.jpg
// module id = 392
// module chunks = 3627797113349 20562973939449 33019919093843